import { render, staticRenderFns } from "./ButtonAddInsight.vue?vue&type=template&id=5c773e0e&scoped=true&"
import script from "./ButtonAddInsight.vue?vue&type=script&lang=js&"
export * from "./ButtonAddInsight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c773e0e",
  null
  
)

export default component.exports